import Vue from 'vue'
import Router from 'vue-router'
// import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/wechat/login/',
      name: '微信扫码登录',
      meta: {
        id: 'wechat.login.redirected',
        type: 'h5'
      },
      component: () => import('@/views/wechat/Login.vue')
    },
    {
      path: '/',
      name: '首页',
      meta: {
        id: 'home',
        type: 'desktop'
      },
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/:category/list',
      name: '最新公告',
      meta: {
        id: 'news',
        type: 'desktop'
      },
      component: () => import('@/views/announcement/Index.vue')
    },
    {
      path: '/document/:category',
      name: '资料馆',
      meta: {
        id: 'document',
        type: 'desktop'
      },
      component: () => import('@/views/document/Index.vue')
    },
    {
      path: '/ceramic',
      name: '珍品瓷器',
      meta: {
        id: 'ceramic',
        type: 'desktop'
      },
      component: () => import('@/views/ceramic/Index.vue')
    },
    {
      path: '/ceramic/:ceramicUuid',
      name: '珍品瓷器详情',
      meta: {
        type: 'h5'
      },
      component: () => import('@/views/ceramic/Detail.vue')
    },
    {
      path: '/:category/info',
      name: '详情',
      meta: {
        type: 'desktop'
      },
      component: () => import('@/views/info/Index.vue')
    },
    {
      path: '/tour/:category?',
      name: '游览须知',
      meta: {
        id: 'tour',
        type: 'desktop'
      },
      component: () => import('@/views/page/Index.vue')
    },
    {
      path: '/panorama/',
      name: '全景御窑',
      meta: {
        id: 'panorama',
        type: 'desktop'
      },
      component: () => import('./views/panorama/Index.vue')
      // children: [
      //   {
      //     path: 'desktop/',
      //     name: 'panorama.desktop',
      //     meta: {
      //       id: 'panorama.desktop',
      //       type: 'desktop'
      //     },
      //     component: () => import('@/views/panorama/vr/Index.vue')
      //   },
      //   {
      //     path: 'h5/',
      //     name: 'panorama.h5',
      //     meta: {
      //       id: 'panorama',
      //       type: 'h5'
      //     },
      //     component: () => import('@/views/panorama/vrPhone/Index.vue')
      //   }
      // ]
    },
    {
      path: '/panorama/desktop/',
      name: '全景御窑pc',
      meta: {
        id: 'panorama',
        type: 'desktop'
      },
      component: () => import('@/views/panorama/vr/Index.vue')
    },
    {
      path: '/panorama/h5/',
      name: '全景御窑h5',
      meta: {
        id: 'panorama',
        type: 'h5'
      },
      component: () => import('@/views/panorama/vr/Index.vue')
    },
    {
      path: '/porcelain/:id',
      name: 'porcelain.detail',
      meta: {
        name: 'detail',
        type: 'h5',
        calssName: ''
      },
      component: () => import('@/views/porcelain/MiniDetail.vue')
    },
    {
      path: '/me/',
      name: '个人中心',
      meta: {
        id: 'me',
        type: 'desktop'
      },
      component: () => import('./views/me/Index.vue')
      // children: [
      //   {
      //     path: 'basicData/',
      //     name: 'me.basicData',
      //     meta: {
      //       id: 'basicData',
      //       type: 'desktop'
      //     },
      //     component: () => import('@/views/me/basicData/Index.vue')
      //   },
      //   {
      //     path: 'articleCollections/',
      //     name: 'me.articleCollections',
      //     meta: {
      //       id: 'articleCollections',
      //       type: 'desktop'
      //     },
      //     component: () => import('@/views/me/articleCollections/Index.vue')
      //   },
      //   {
      //     path: 'ceramicCollections/',
      //     name: 'me.ceramicCollections',
      //     meta: {
      //       id: 'ceramicCollections',
      //       type: 'desktop'
      //     },
      //     component: () => import('@/views/me/ceramicCollections/Index.vue')
      //   }
      // ]
    },
    {
      path: '/search/:type',
      name: '搜索',
      meta: {
        id: 'search',
        type: 'desktop'
      },
      component: () => import('@/views/search/Index.vue')
    },
    {
      path: '/about/:category',
      name: '关于我们',
      meta: {
        id: 'about',
        type: 'desktop'
      },
      component: () => import('@/views/about/Index.vue')
    },
    {
      path: '/link',
      name: '友情链接',
      meta: {
        id: 'link',
        type: 'desktop'
      },
      component: () => import('@/views/link/Index.vue')
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   console.log({ to, from, next }) // eslint-disable-line no-console
//   if (to.meta.type !== 'h5') {
//     store.dispatch('CategoriesStore/fetch') // nav信息
//     store.dispatch('CarouselsStore/fetch') // 首页轮播图
//     store.dispatch('SubscriberStore/fetch') // 获取个人信息
//     store.dispatch('HomeStore/getHome') // 首页站点数据
//     store.dispatch('PanoramasStore/fetch') // 全景
//     store.dispatch('SchemaConfigStore/fetch') // 获取瓷器条件
//   }
//   next()
// })

export default router
